import styled, { css } from 'styled-components';

export const CardContainer = styled.div<{
  /** Color of the background. Use theme values. */
  $backgroundColor?: string;
  /** Color of the border. Use theme values. */
  $borderColor?: string;
  /** Border radius. Use theme values. */
  $borderRadius?: string;
  /** Spacing around card. Use theme values. */
  $padding?: string;
  /** If true, uses flex styles for the height so the content can grow vertically */
  $flexHeight?: boolean;
}>(
  ({ theme, $backgroundColor, $borderColor, $borderRadius, $padding, $flexHeight }) => css`
    background-color: ${$backgroundColor || theme.co.neutral99};
    border: ${$borderColor ? `${theme.bo.mediumWidth} solid ${$borderColor}` : 'none'};
    width: 100%;
    border-radius: ${$borderRadius ?? theme.bo.mediumLarge};
    padding: ${$padding};
    position: relative;

    ${$flexHeight &&
    css`
      display: flex;
      flex-direction: column;
    `}
  `,
);

interface TextProps {
  /** Removes bottom margin if true. */
  $noMargin?: boolean;
  /** Size of the text. Use theme values. */
  $fontSize?: string;
}

export const Heading = styled.h3<TextProps>(
  ({ theme, $noMargin, $fontSize }) => css`
    position: relative;
    margin: 0;
    margin-bottom: ${$noMargin ? 0 : theme.sz.s4};
    color: ${theme.co.secondary20};
    font-size: ${$fontSize || theme.DEPRECATED_ty.large};
  `,
);

export const Text = styled.p<TextProps>(
  ({ theme, $noMargin, $fontSize }) => css`
    position: relative;
    margin: 0;
    margin-bottom: ${$noMargin ? 0 : theme.sz.s4};
    color: ${theme.co.secondary50};
    font-size: ${$fontSize || theme.DEPRECATED_ty.medium};
  `,
);

export const TopRightBg = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.sz.s2};
    right: ${theme.sz.s2};
  `,
);

export const Sections = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    @media (max-width: ${theme.sz.lg}) {
      flex-direction: column;
      align-items: start;

      > &:not(:first-child) {
        margin-top: ${theme.sz.s4};
      }
    }
  `,
);
